function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.54127 2.05787C9.71535 1.65643 10.2846 1.65643 10.4587 2.05787L12.3266 6.36528C12.399 6.53236 12.5566 6.64683 12.7379 6.66411L17.4117 7.10947C17.8473 7.15098 18.0232 7.69241 17.6952 7.98202L14.1758 11.0895C14.0393 11.21 13.9791 11.3953 14.0187 11.573L15.0394 16.1557C15.1345 16.5828 14.6739 16.9174 14.2972 16.695L10.2542 14.3081C10.0974 14.2155 9.90262 14.2155 9.7458 14.3081L5.70285 16.695C5.32606 16.9174 4.86548 16.5828 4.96061 16.1557L5.98133 11.573C6.02092 11.3953 5.96074 11.21 5.82423 11.0895L2.30483 7.98202C1.97683 7.69241 2.15275 7.15098 2.58834 7.10947L7.26213 6.66411C7.44342 6.64683 7.60098 6.53236 7.67343 6.36528L9.54127 2.05787Z",
  stroke: "black"
});

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star.c2448b49.svg";
export { ForwardRef as ReactComponent };